import {
  faBriefcase,
  faBuilding,
  faHouse,
  faLocationDot,
  faSearch,
  faXmark,
  faReceipt,
  faTruckFast,
} from "@fortawesome/free-solid-svg-icons";
import "./AddNewAddress.css";
import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Select from "react-select";
import { Button, Form, InputGroup } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import classNames from "classnames";
import PhoneInput from "react-phone-input-2";
import { useNavigate, useParams } from "react-router-dom";
import Gray_Btn from "../common_components/common_btn/gray_btn/Gray_Btn";
import "react-phone-input-2/lib/style.css";
// import Your_Location_Info_Modal from "../common_components/common_modal/your_location_info_modal/Your_Location_Info_Modal";
import { useDispatch, useSelector } from "react-redux";
import {
  AllCity,
  AllPincode,
  AllState,
  getAllCountries,
} from "../../features/master/masterSlice";
import {
  createOrderAddress,
  EditOrderAddress,
  getSingleOrderAddress,
} from "../../features/order/orderSlice";
import {
  getLocationFromSession,
  setCurrentLocation,
} from "../../features/location/locationSlice";
import axios from "axios";
import Cookies from "js-cookie";
import Blue_Btn from "../common_components/common_btn/Blue_Btn/Blue_Btn";
const EditNewAddress = (props) => {
  const [showModal, setShowModal] = useState(false);

  const navigate = useNavigate();

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();
  const dispatch = useDispatch();
  const [activeBtn, setActiveBtn] = useState(1);
  // const [id, setId] = useState();
  const { id } = useParams();
  const [isUpdate, setIsUpdate] = useState();

  const countries = useSelector((state) => state.master.all_country);
  const states = useSelector((state) => state.master.all_state);
  const cities = useSelector((state) => state.master.all_city);
  const pincodes = useSelector((state) => state.master.all_pincode);
  const [addressType, setAddressType] = useState(1);

  useEffect(() => {
    dispatch(getAllCountries());
  }, [dispatch]);

  const handleCountryChange = (selectedOption) => {
    // console.log(selectedOption, "handleCountryChange");
    setValue("country_id", selectedOption?.value);
    setValue("state_id", null);
    setValue("city_id", null);
    setValue("pincode_id", null);
    dispatch(AllState({ countryId: selectedOption?.value }));
  };

  const handleStateChange = (selectedOption) => {
    // console.log(selectedOption, "handleStateChange");
    setValue("state_id", selectedOption.value);
    setValue("city_id", null);
    setValue("pincode_id", null);
    dispatch(AllCity({ stateId: selectedOption.value }));
  };

  const handleCityChange = (selectedOption) => {
    // console.log(selectedOption, "handleCityChange");

    setValue("city_id", selectedOption?.value);
    setValue("pincode_id", null);
    dispatch(AllPincode({ cityId: selectedOption.value }));
  };

  const handlePincodeChange = (selectedOption) => {
    // console.log(selectedOption, "handlePincodeChange");
    setValue("pincode_id", selectedOption?.value);
  };

  const current_location = useSelector(
    (state) => state.location.current_location,
  );
  useEffect(() => {
    dispatch(getLocationFromSession());
  }, [dispatch]);

  const handleUpdate = async (data) => {
    const DataToSend = new FormData();
    DataToSend.append("user_address_type_id", addressType);
    DataToSend.append("address_type_id", activeBtn);

    DataToSend.append(
      "lat",
      current_location?.geometry?.location?.lat ||
        current_location?.coordinates?.lat,
    );
    DataToSend.append(
      "long",
      current_location?.geometry?.location?.lng ||
        current_location?.coordinates?.lng,
    );
    // DataToSend.append("country_id", data?.country_id?.value);
    // DataToSend.append("state_id", data?.state_id?.value);
    DataToSend.append("city_id", data?.city_id?.value);
    DataToSend.append("pincode_id", data?.pincode_id?.value);

    DataToSend.append("building", data?.building);
    DataToSend.append("apartment", data?.apartment); //society
    DataToSend.append("area", data?.area);
    DataToSend.append("first_name", data?.name);
    DataToSend.append("street", data?.street);
    DataToSend.append("contact_no", data?.contact_no);
    DataToSend.append("floor", data?.floor);
    DataToSend.append("direction", data?.direction);
    DataToSend.append("socity_name", data?.socity_name);

    const res = await dispatch(EditOrderAddress({ id, data: DataToSend }));

    if (res.meta?.requestStatus === "fulfilled") {
      setIsUpdate(false);

      navigate("/saved-address");
      reset();
    } else if (res.meta?.requestStatus === "rejected") {
      setIsUpdate(false);
      if (res.payload?.errors) {
        setError("building", {
          type: "manual",
          message: res.payload?.errors,
        });
      }
      // if (res.payload?.errors) {
      //   setError("contact_no", {
      //     type: "manual",
      //     message: res.payload?.errors,
      //   });
      // }
    }
  };

  const getSingleAddress = async () => {
    const res = await dispatch(getSingleOrderAddress({ id: id }));
    if (res.meta?.requestStatus === "fulfilled") {
      reset(res.payload?.data);
      setActiveBtn(res.payload?.data?.address_type_id);
      setAddressType(res.payload?.data?.user_address_type_id);
    } else if (res.meta?.requestStatus === "rejected") {
      setIsUpdate(false);
    }
  };

  useEffect(() => {
    if (id) {
      setIsUpdate(true);
    }
    getSingleAddress();
  }, [dispatch, id]);

  useEffect(() => {
    if (current_location?.formatted_address) {
      setValue("street", current_location.formatted_address);
    }
  }, [current_location, setValue]);

  return (
    <section className="AddNewAddress">
      <div className="container">
        <div className="add_new_address_main_div">
          <div className="data_holder">
            {/* <div className={"map-section"}>
              <div className="mapouter">
                <div className="gmap_canvas">
                  <iframe
                    className="gmap_iframe"
                    // src={`https://www.google.com/maps/embed/v1/place?key=${apiKey}&q=${current_location?.raw?.geometry?.lat},${current_location?.raw?.geometry?.lng}`}
                    src={`https://maps.google.com/maps?q=${current_location?.geometry?.location?.lat},${current_location?.geometry?.location?.lng}&hl=en&z=14&output=embed`}
                    allowFullScreen=""
                    loading="lazy"
                  ></iframe>
                  <a href="https://pdflist.com/" alt="pdflist.com"></a>
                </div>
              </div>
              <div className={"overlaycolor"}></div>

              <div className="area_main_div">
                <div className="icon_holder">
                  <FontAwesomeIcon
                    icon={faLocationDot}
                    className="location_icon"
                  />
                </div>

                <div className="area_div">
                  <p className="area_heading">Area</p>

                  <div className="footer_text">
                    <div className="">
                      <p className="city_name">
                        {current_location?.formatted_address}
                      </p>
                    </div>

                    <div
                      className="right_side_text"
                      onClick={() => {
                        setShowModal(true);
                      }}
                    >
                      <p className="green_text_underline">Change</p>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
            {/* <div className={"map-section"}>
            <div className="search-field-holder">
              <div className="search-field">
                <InputGroup className="mb-3">
                  <InputGroup.Text id="basic-addon1">
                    <FontAwesomeIcon icon={faSearch} />
                  </InputGroup.Text>
                  <Form.Control
                    placeholder="Search Locations"
                    aria-label="Search Locations"
                    aria-describedby="basic-addon1"
                    value={searchQuery}
                    onChange={(event) => setSearchQuery(event.target.value)}
                  />

                  <InputGroup.Text
                    onClick={handleClearSearch}
                    className="clear-icon"
                  >
                    <FontAwesomeIcon icon={faXmark} />
                  </InputGroup.Text>
                </InputGroup>

               
              </div>
            </div>
            <div
              id="map"
              ref={mapRef}
              style={{ width: "100%", height: "500px" }}
            ></div>
            <div className="area_div">
              <p className="area_heading">Area</p>

              <div className="footer_text">
                <div className="">
                  <p className="city_name">
                    {current_location?.formatted_address}
                  </p>
                </div>

                <div
                  className="right_side_text"
                  onClick={() => {
                    setShowModal(true);
                  }}
                >
                  <p className="green_text_underline">Change</p>
                </div>
              </div>
            </div></div> */}

            <div className="address_form_main_div">
              <div className="address_type_btn_holder">
                <div
                  className={`address_type_btn ${
                    addressType === 1 ? "active" : ""
                  }`}
                  onClick={() => {
                    setAddressType(1);
                  }}
                >
                  <div className="icon_holder">
                    <FontAwesomeIcon icon={faTruckFast} className="type_icon" />
                  </div>

                  <div className="address_type">
                    <p>Shipping Address</p>
                  </div>
                </div>

                <div
                  className={`address_type_btn ${
                    addressType === 2 ? "active" : ""
                  }`}
                  onClick={() => {
                    setAddressType(2);
                  }}
                >
                  <div className="icon_holder">
                    <FontAwesomeIcon icon={faReceipt} className="type_icon" />
                  </div>

                  <div className="address_type">
                    <p>Billing Address</p>
                  </div>
                </div>
              </div>

              <div className="address_type_btn_holder">
                <div
                  className={`address_type_btn ${
                    activeBtn === 2 ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveBtn(2);
                  }}
                >
                  <div className="icon_holder">
                    <FontAwesomeIcon icon={faBuilding} className="type_icon" />
                  </div>

                  <div className="address_type">
                    <p>Apartment</p>
                  </div>
                </div>

                <div
                  className={`address_type_btn ${
                    activeBtn === 1 ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveBtn(1);
                  }}
                >
                  <div className="icon_holder">
                    <FontAwesomeIcon icon={faHouse} className="type_icon" />
                  </div>

                  <div className="address_type">
                    <p>House</p>
                  </div>
                </div>

                <div
                  className={`address_type_btn ${
                    activeBtn === 4 ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveBtn(4);
                  }}
                >
                  <div className="icon_holder">
                    <FontAwesomeIcon icon={faBriefcase} className="type_icon" />
                  </div>

                  <div className="address_type">
                    <p>Office</p>
                  </div>
                </div>
              </div>

              <Form className="form_div">
                <div className="row">
                  <div className="col-lg-6 col-md-6 mb-3">
                    <Form.Control
                      type="text"
                      name="building"
                      placeholder={
                        activeBtn === 1
                          ? "House name*"
                          : activeBtn === 2
                          ? "Apartment name*"
                          : "Office Name*"
                      }
                      {...register("building", {
                        required:
                          activeBtn === 1
                            ? "Building name required"
                            : activeBtn === 2
                            ? "Apartment name required"
                            : "Office name required",
                      })}
                    />
                    {errors?.building && (
                      <div style={{ fontSize: "13px", color: "red" }}>
                        {errors?.building?.message}
                      </div>
                    )}
                  </div>

                  <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                    <Form.Control
                      type="text"
                      name="apartment"
                      placeholder={
                        activeBtn === 1
                          ? "House no.*"
                          : activeBtn === 2
                          ? "Apartment No*"
                          : "Office No*"
                      }
                      {...register("apartment", {
                        // required:
                        //   activeBtn === 1
                        //     ? "House no. required"
                        //     : activeBtn === 2
                        //     ? "Apartment required"
                        //     : "Office No required",
                      })}
                    />
                    {errors?.apartment && (
                      <div style={{ fontSize: "13px", color: "red" }}>
                        {errors?.apartment?.message}
                      </div>
                    )}
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-6 col-md-6  mb-3">
                    <Form.Control
                      type="text"
                      name="floor"
                      placeholder="Floor*"
                      {...register("floor", {
                        // required: "Floor required",
                      })}
                    />
                    {errors?.floor && (
                      <div style={{ fontSize: "13px", color: "red" }}>
                        {errors?.floor?.message}
                      </div>
                    )}
                  </div>
                  <div className="col-lg-6 col-md-6  mb-3">
                    <Form.Control
                      type="text"
                      name="area"
                      placeholder="Area Name"
                      {...register("area", {
                        // required: "Area Name required",
                      })}
                    />
                    {errors?.area && (
                      <div style={{ fontSize: "13px", color: "red" }}>
                        {errors?.area?.message}
                      </div>
                    )}
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 mb-3">
                    <Form.Control
                      as="textarea"
                      rows={3}
                      type="text"
                      name="street"
                      placeholder="Street*"
                      {...register("street", {
                        required: "Street name required",
                      })}
                      // className={classNames("", {
                      //   "is-invalid": errors?.street,
                      //   "is-valid": getValues("street"),
                      // })}
                    />
                    {errors?.street && (
                      <div style={{ fontSize: "13px", color: "red" }}>
                        {errors?.street?.message}
                      </div>
                    )}
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-6 col-md-6 mb-3">
                    <Form.Control
                      type="text"
                      name="direction"
                      placeholder="Additional directions (optional)"
                      {...register("direction", {
                        // required: "Additional directions are required",
                      })}
                      className={classNames("", {
                        "is-invalid": errors?.direction,
                        "is-valid": getValues("direction"),
                      })}
                    />
                    {errors?.direction && (
                      <div style={{ fontSize: "13px", color: "red" }}>
                        {errors?.direction?.message}
                      </div>
                    )}
                  </div>
                  <div className="col-lg-6 col-md-6 mb-3">
                    <Controller
                      className="phone_input"
                      name="contact_no"
                      control={control}
                      rules={{
                        required: "contact_no is required",
                        minLength: {
                          value: 10,
                          message: "Number should be at least 10 characters",
                        },
                      }}
                      render={({ field }) => (
                        <PhoneInput
                          country="in"
                          {...field}
                          className={classNames("", {
                            "is-invalid": errors?.contact_no,
                            "is-valid": getValues("contact_no"),
                          })}
                          onChange={(value) => field.onChange(value)}
                          type="text"
                          placeholder="Enter Mobile Number"
                          maxLength={10}
                        />
                      )}
                    />
                    {errors?.contact_no && (
                      <div style={{ fontSize: "13px", color: "red" }}>
                        {errors?.contact_no?.message}
                      </div>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-3 col-md-6 col-sm-6 col-12 mb-3">
                    <Controller
                      className="Select_Dropdown_holder"
                      name="city_id" // Form field name
                      control={control}
                      rules={{ required: "City is required" }}
                      render={({ field }) => (
                        <Select
                          className="mb-3"
                          placeholder="Select City"
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.city_id ? "red" : baseStyles,
                            }),
                          }}
                          {...field}
                          options={cities}
                          onChange={(selectedOption) => {
                            field.onChange(selectedOption.value); // Update Controller's value
                            handleCityChange(selectedOption);
                            setValue("city_id", selectedOption);
                          }}
                        />
                      )}
                    />
                    {errors?.city_id && (
                      <div style={{ fontSize: "13px", color: "red" }}>
                        {errors?.city_id?.message}
                      </div>
                    )}
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-6 col-12 mb-3">
                    <Controller
                      className="Select_Dropdown_holder"
                      name="pincode_id" // Form field name
                      control={control}
                      rules={{ required: "Pincode is required" }}
                      render={({ field }) => (
                        <Select
                          className="mb-3"
                          placeholder="Select Pincode"
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.pincode_id
                                ? "red"
                                : baseStyles,
                            }),
                          }}
                          {...field}
                          options={pincodes}
                          onChange={(selectedOption) => {
                            field.onChange(selectedOption.value); // Update Controller's value
                            handlePincodeChange(selectedOption);
                            setValue("pincode_id", selectedOption);
                          }}
                        />
                      )}
                    />
                    {errors?.pincode_id && (
                      <div style={{ fontSize: "13px", color: "red" }}>
                        {errors?.pincode_id?.message}
                      </div>
                    )}
                  </div>
                </div>
              </Form>

              <div className="text-center btn_holder">
                <Blue_Btn
                  btnText="Save Address"
                  onClick={handleSubmit(handleUpdate)}
                />

                <Gray_Btn
                  btn_name="Cancel"
                  onClick={() => {
                    navigate("/saved-address");
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <Your_Location_Info_Modal
        current_location={current_location}
        btnText="Enter Complete Address"
        show={showModal}
        onHide={() => setShowModal(false)}
        orange_btn_text={"Enter Address"}
        green_btn_text={"Verify Address"}
        showText={false}
        modalTitle="Your Location Info"
      /> */}
    </section>
  );
};

export default EditNewAddress;
